import { createSlice } from '@reduxjs/toolkit';


const helperSlice = createSlice({
    name: 'helper',
    initialState: {
        layers: localStorage.getItem('layers') ? JSON.parse(localStorage.getItem('layers')) : {
            baseLayer: 1,
            overlayLayers: {
                res: true,
                powerPlants: true,
                feedingSubstations: true,
                transformers: true,
                fider330: true,
                fider110: true,
                fider35: true,
                fider10: true,
                fider10_04: true,
                fider6: true,
                fider04: true,
                pillar10: true,
                pillar04_10: true,
                pillar04: true,
                zvz: true,
                opn: true,
                rlnd: true,
                runn: true,
            },
            dataLayers: {
                viewPlan: false,
                viewProjectStatus: false,
                viewMounted: false,
                viewFiderDistances: false,

            },
            settings: {
                brightness: 100,
                contrast: 100,
                saturation: 100,
                opacity: 100,
            }
        },
        address: null,
        // accountingControl: localStorage.getItem('accountingControl') ? JSON.parse(localStorage.getItem('accountingControl')) :{
        //     hidden: false, 
        //     accordions: []
        // },
        filterDates: null,
        filter: null,
        printing: null,
        drawing: { state: false, source: null, mode: null },
        showMounted: localStorage.getItem('showMounted') ? JSON.parse(localStorage.getItem('showMounted')) : false,
        dial: null,
        modal: null,
        popup: null,
        distances: {
            fider04: 0,
            'fider10-04': 0,
            fider6: 0,
            fider10: 0,
            fider330: 0,
            fider110: 0,
            fider35: 0,
        },
        darkMode: localStorage.getItem('darkMode') ? JSON.parse(localStorage.getItem('darkMode')) : false,
        // null - скрыть имена
        // true - показать/скрыть предписания
        // false - сокращенная запись предписаний
        displayNames: localStorage.getItem('displayNames') ? JSON.parse(localStorage.getItem('displayNames')) : { text: true, accounting: true, accounting_completed: true, accountingid: false },
        extendedNames: localStorage.getItem('extendedNames') ? JSON.parse(localStorage.getItem('extendedNames')) : { state: true },
        charWidths: {}
    },
    reducers: {
       
        setBaseLayer(state, action) {
            console.log('setBaseLayer', action.payload)
            state.layers.baseLayer = action.payload
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },
        setOverlayLayer(state, action) {
            console.log('setOverlayLayer', action)
            state.layers.overlayLayers[action.payload.name] = action.payload.state
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },
        setDataLayer(state, action) {
            console.log('setDataLayer', action.payload)
            state.layers.dataLayers[action.payload.name] = action.payload.state
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },


        setAddress(state, action) {
            state.address = action.payload
        },

        setFilterDates(state, action) {

            if (action.payload) {
                state.filterDates = action.payload

            }
        },

        setExtendedNames(state, action) {
            state.extendedNames = { state: action.payload }
            localStorage.setItem('extendedNames', JSON.stringify(state.extendedNames))
        },

        setDisplayNames(state, action) {
            state.displayNames = action.payload
            localStorage.setItem('displayNames', JSON.stringify(state.displayNames))
        },

        setPrinting(state, action) {
            state.printing = action.payload
        },
        setMeasuring(state, action) {
            state.measuring = action.payload
        },
        setDrawing(state, action) {
            state.drawing = action.payload
        },
        

        setDial(state, action) {
            state.dial = action.payload
            if (state.filter) {
                localStorage.setItem('dial', JSON.stringify(state.dial))
            } else {
                localStorage.removeItem('dial')
            }

        },

        setModal(state, action) {
            state.modal = action.payload
        },
        setDistances(state, action) {
            const { layer, distance } = action.payload
            state.distances[layer] = distance
        },
        setShowMounted(state, action) {
            state.showMounted = action.payload
            localStorage.setItem('showMounted', JSON.stringify(state.showMounted))
        },
        setDarkMode(state, action) {
            state.darkMode = action.payload
            localStorage.setItem('darkMode', JSON.stringify(state.darkMode))
        },
        setCharWidths(state, action) {
            state.charWidths = action.payload
        },
        setMapSettings(state, action) {
            state.layers.settings = { ...state.layers.settings, ...action.payload }
            localStorage.setItem('layers', JSON.stringify(state.layers))
        }
    }
});


export const { setLayers, setLayersOptimized, setBaseLayer, setOverlayLayer, setDataLayer, setAddress, setFilterDates, setExtendedNames, setPrinting, setMeasuring, setDial, setModal, setDistances, setShowMounted, setDarkMode, setCharWidths, setDrawing, setMapSettings } = helperSlice.actions;
export default helperSlice.reducer;